import { KeycloakFeature, withAutoRefreshToken, ProvideKeycloakOptions, AutoRefreshTokenService, UserActivityService, provideKeycloak } from "keycloak-angular";
import { KeycloakInitOptions, KeycloakOnLoad } from "keycloak-js";
import keycloakConfig from "../../environments/environment";

const keycloakInitOptions: KeycloakInitOptions = {
    onLoad: 'login-required' as KeycloakOnLoad,
    checkLoginIframe: false,
    locale: 'it',
    refreshToken: "120",
    checkLoginIframeInterval: 380,
    flow: "standard",
    pkceMethod:'S256'
}

const keycloakFeature: KeycloakFeature[] = [
    withAutoRefreshToken({
        sessionTimeout: 300000,
        onInactivityTimeout: 'logout'
    })
];

const provideKeycloakOptions: ProvideKeycloakOptions = {
    config: keycloakConfig,
    initOptions: keycloakInitOptions,
    features: keycloakFeature,
    providers: [
        AutoRefreshTokenService,
        UserActivityService
    ]
}

export const provideKeycloakAngular = () => provideKeycloak(provideKeycloakOptions);

